export default __webpack_public_path__ + "a7b062365a613f6511d807dd3f22f08d.png";